import { render, staticRenderFns } from "./RegressionCode.vue?vue&type=template&id=95ea35ce"
import script from "./RegressionCode.vue?vue&type=script&lang=js"
export * from "./RegressionCode.vue?vue&type=script&lang=js"
import style0 from "./RegressionCode.vue?vue&type=style&index=0&id=95ea35ce&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports